<n-slide-window id="task-s-config" class="shadow-none" [(visible)]="windowVisible"
    (onHide)="close()" [showMask]="false" [fullScreen]="true">
    <div class="task-s-main">
        <h2>
            <svg id="back-btn" (click)="close()">
                <use xlink:href="#app-icon-smart-assistant-back"></use>
            </svg>
            <span>{{ taskCentertitle }}</span>
        </h2>

        <app-task #appTask [taskId]="taskId"></app-task>
    </div>
</n-slide-window>
